import { apiClient } from '@/shared/api/client'

export async function getMarketingDashboard(params = {}) {
  const response = await apiClient.get('/marketing/dashboard', { params })
  return response.data
}
